import { jsx as _jsx } from "react/jsx-runtime";
import { CatButton } from '@blocks-react/components/Button';
export const RegisterButton = ({ children, className, onClick, href, variant, fullWidth = true, gaAttributes = {} }) => {
    return (_jsx(CatButton, { className: className, fullWidth: fullWidth, onClick: onClick, "data-testid": "register-button", href: href, variant: variant, ...gaAttributes, children: children }));
};
